module.exports = __webpack_public_path__ + "static/img/top1_i8_nav.86008dee.png";